// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-remote-security-training.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-remote-security-training',
  title:
    'Train employees in secure use of remote access, VPN, home networks and communications tools',
  description:
    'Employees must be trained in the secure use of: voice and conference calling services; access control mechanisms such as tokens and passwords; home networks including router hardening; encrypted network connections (VPN); and electronic communication tools including email and collaboration platforms.',
  category: 'people',
  scfIds: ['SCF-PPL-003', 'SCF-NET-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Remote and communications security training content is documented',
    },
    { type: 'document-within-sla', description: 'Training content is current' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
